import { createExternalRouteRef } from '@backstage/core-plugin-api';

export const entitiesRouteRef = createExternalRouteRef({
  id: 'entities',
  optional: true,
});
